export enum SearchMethod {
  SearchByLocation = 'Search by location',
  SearchByShopName = 'Search by shop name',
}
